<template>
  <div>
    <div id="contrasenaNoValidada_div" class="d-none justify-content-center align-items-center">
      <div id="cambioDeContrasena" class="d-flex justify-content-center align-items-center">
        <div class="flex-wrap">
          <h3 class="w-100">CAMBIO DE CONTRASEÑA</h3>
          <h6 class="w-100">Su contraseña falta de ser validada.<br />Cambie su contraseña para poder continuar.</h6>
          <h6 class="w-100">El cambio de contraseña tambien afecta a su cuenta de MAJAT</h6>
          <nuevaContrasena class="nuevaContrasena" v-bind:requiereIngresarLaContrasenaActual="requiereIngresarLaContrasenaActual"></nuevaContrasena>
        </div>
      </div>      
    </div>
  </div>

</template>

<script>
  import nuevaContrasena from '../../../src/components/Cuentas/Comun/Contrasena/NuevaContrasena.vue'

  export default {
    name: 'App',
    components: {
      nuevaContrasena
    },
    data() {
      return {
        requiereIngresarLaContrasenaActual: false
      }
    },
    methods: {
      
    }
  }
</script>


<style scoped>
  #contrasenaNoValidada_div {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 40 !important;
  }

    #contrasenaNoValidada_div > #cambioDeContrasena > div {
      background: rgba(34,34,34,1);
      width: 440px;
      height: 545px;
      padding-left: 5vh;
      padding-right: 5vh;
      margin-top: -200px !important;
    }

    #contrasenaNoValidada_div > #cambioDeContrasena {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 4vh;
  }

  h6 {
    color: #FFFFFF;
  }

  .nuevaContrasena {
    margin-top: 3vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/ContrasenaNoValidada.vue